import { ApartmentStatus } from "../../types/propertyInventory/ApartmentComplex";

// Propiedades solitarias (una sola unidad)
export const singleProperties = [
  {
    id: 1,
    name: 'Casa Familiar San Pedro',
    location: 'San Pedro, San José',
    type: 'Casa',
    bedrooms: 3,
    bathrooms: 2,
    monthlyPrice: 650000,
    currency: 'CRC',
    status: 'occupied',
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=400&h=300&fit=crop',
    tenant: {
      name: 'Carlos Rodríguez',
      phone: '+506 8888-1234'
    }
  },
  {
    id: 2,
    name: 'Apartamento Centro Chepe',
    location: 'San José Centro',
    type: 'Apartamento',
    bedrooms: 1,
    bathrooms: 1,
    monthlyPrice: 480000,
    currency: 'CRC',
    status: 'available',
    image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=400&h=300&fit=crop',
    tenant: null
  },
  {
    id: 3,
    name: 'Casa Moderna Escazú',
    location: 'Escazú, San José',
    type: 'Casa',
    bedrooms: 4,
    bathrooms: 3,
    monthlyPrice: 1200000,
    currency: 'CRC',
    status: 'occupied',
    image: 'https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=400&h=300&fit=crop',
    tenant: {
      name: 'Ana Martínez',
      phone: '+506 7777-5678'
    }
  },
  {
    id: 4,
    name: 'Apartamento Vista Mar',
    location: 'Puntarenas Centro',
    type: 'Apartamento',
    bedrooms: 2,
    bathrooms: 2,
    monthlyPrice: 550000,
    currency: 'CRC',
    status: 'maintenance',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=400&h=300&fit=crop',
    tenant: null
  },
  {
    id: 5,
    name: 'Casa Campestre Cartago',
    location: 'Cartago Centro',
    type: 'Casa',
    bedrooms: 2,
    bathrooms: 1,
    monthlyPrice: 350000,
    currency: 'CRC',
    status: 'available',
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=300&fit=crop',
    tenant: null
  }
];

export const getStatusColor = (status: ApartmentStatus) => {
  switch (status) {
    case ApartmentStatus.DISPONIBLE: return '#4CAF50';
    case ApartmentStatus.OCUPADO: return '#FF9800';
    case ApartmentStatus.NO_DISPONIBLE: return '#F44336';
    default: return '#9E9E9E';
  }
};

export const getStatusText = (status: ApartmentStatus) => {
  switch (status) {
    case ApartmentStatus.DISPONIBLE: return 'Disponible';
    case ApartmentStatus.OCUPADO: return 'Ocupado';
    case ApartmentStatus.NO_DISPONIBLE: return 'Mantenimiento';
    default: return 'Desconocido';
  }
};